import React from 'react'
import Link from 'gatsby-link'

import Github from '../assets/images/icons/github.svg'
import Twitter from '../assets/images/icons/twitter.svg'
import Linkedin from '../assets/images/icons/linkedin.svg'
import Instagram from '../assets/images/icons/instagram.svg'

const Header = ({ siteTitle }) => (
  <div
    style={{
      marginBottom: '1.45rem',
    }}
  >
    <div
      style={{
        margin: '0 auto',
        maxWidth: 960,
      }}
    >
      <a href="/">
        <div className={'logo'}>SK</div>
      </a>
      <div className={'social-container'}>
        <a href="https://github.com/stevica" target={'_blank'}>
          <img className={'social-icon'} src={Github} alt="Github" />
        </a>
        <a href="https://twitter.com/knezevic84" target={'_blank'}>
          <img className={'social-icon'} src={Twitter} alt="Twitter" />
        </a>
        <a href="https://www.linkedin.com/in/stevicaknezevic" target={'_blank'}>
          <img className={'social-icon'} src={Linkedin} alt="Linkedin" />
        </a>
        <a href="https://www.instagram.com/knezevicsteva" target={'_blank'}>
          <img className={'social-icon'} src={Instagram} alt="Instagram" />
        </a>
      </div>
    </div>
  </div>
)

export default Header



// WEBPACK FOOTER //
// ./src/components/header.js